// client/src/redux/features/userSlice.js
import { createSlice } from "@reduxjs/toolkit";

const normalizeUser = (u) => {
  if (!u || typeof u !== "object") return null;

  const balanceNum =
    typeof u.balance === "number"
      ? u.balance
      : typeof u.balance === "string"
      ? Number(u.balance)
      : 0;

  return {
    id:             u.id || u._id || null,
    email:          typeof u.email === "string" ? u.email : "",
    fname:          typeof u.fname === "string" ? u.fname : "",
    isAdmin:        !!u.isAdmin,
    block:          u.block === "yes" ? "yes" : "no",
    reseller:       u.reseller === "yes" ? "yes" : "no",
    resellerExpiry: u.resellerExpiry || null,
    resellerSource: u.resellerSource || null,
    picture:        typeof u.picture === "string" ? u.picture : null,
    balance:        Number.isFinite(balanceNum) && balanceNum >= 0 ? balanceNum : 0,
  };
};

export const userSlice = createSlice({
  name: "user",
  initialState: { user: null },
  reducers: {
    setUser: (state, action) => {
      state.user = normalizeUser(action.payload);
    },
    clearUser: (state) => {
      state.user = null;
    },
  },
});

export const { setUser, clearUser } = userSlice.actions;
